import log from "loglevel";
import { ymsapiCoreEndpoint } from "settings";
import * as t from "./types";
import { processServiceResponse } from "lib/request";

/* YardSight-specific Services */
export const ymsDeckingOptimizationTesterService = (
  request: t.YmsDeckingOptimizationTesterRequestType
) => {
  log.info(
    "ymsDeckingOptimizationTesterService Request: " + JSON.stringify(request)
  );
  const SEND_TEST_MESSAGE_ENDPOINT = `${ymsapiCoreEndpoint}/decking/optimize/test/send/`;
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
    body: JSON.stringify(request.body),
  };

  return fetch(SEND_TEST_MESSAGE_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, SEND_TEST_MESSAGE_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const ymsDeckingFilterService = (
  request: t.YmsDeckingFilterRequestType
) => {
  log.info("ymsDeckingFilterService Request: " + JSON.stringify(request));
  const filterAction: string | undefined = request.actionValue;
  let SEND_FILTER_MESSAGE_ENDPOINT = `${ymsapiCoreEndpoint}/decking/filter/send/`;
  if (filterAction) {
    SEND_FILTER_MESSAGE_ENDPOINT += filterAction; // 'submit' or 'delete'
  } else {
    SEND_FILTER_MESSAGE_ENDPOINT += "none"; // API will reject this
  }
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
    body: JSON.stringify(request.body),
  };

  return fetch(SEND_FILTER_MESSAGE_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, SEND_FILTER_MESSAGE_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};
